import React, {useEffect} from 'react';
import { Button } from 'primereact/button';
import {RouteProps, useParams} from 'react-router';
import {useFormData, useFormPage, useFormPageFields, useFormPageSubmission} from 'hooks';
import {FormPageFieldHeader, FormPageFieldInfo, FormsPageSubmissionConfig} from 'types/formPage';
import _ from 'lodash';
import cls from './success-page.module.scss';
import {
    _isBlank,
    insertFieldsState,
    insertRecordFormData, openUrl,
    renderTemplate,
    renderValue,
    toBool,
    toIcon
} from "../../components/utils";
import {useStore} from "../../@redux";
import {Card} from "primereact/card";
import {FormHeader} from "../../components/FormHeader";
import {Branding} from "../../components/Branding";
import { getDevSubmissions} from "../../@redux/formPage/actions";
import {useDispatch} from "react-redux";
import {ProgressBar} from "primereact/progressbar";

type SubmittedProps = RouteProps & {
    mode?:string
};

const Submitted = (props: SubmittedProps) => {
    const {mode = 'live'} = props
  const {root_code, id:formId} = useParams()
  const urlParams = new URLSearchParams(location.search)
  const params = Object.fromEntries(urlParams)
  const store = useStore()
  const {form_code,data:response,original:formDataOrig} = useFormData( `${formId}_submission_response`)  || {} as any
  const form = useFormPage( formId ) || {} as any
  const d = useDispatch()
  useEffect( () => {
      if(mode === 'dev' && formId){
          //get sample submission
          d(getDevSubmissions( d, root_code,  form_code, formId,{id:formId, record_id:formId, params} ) as any)
      }
      window.scrollTo(0, 0)
  }, [formId])
  const isEditMode = `${formId}`.startsWith('rec')
  const toEditUrl = (url, recId) => {
        console.log('toEditUrl', isEditMode, url, recId)
      if(isEditMode)return url
      url += (url.includes('?') ? '&' : '?') + `__refresh_edit__=${recId}`
      return url
  }
  const {  fields:rawFields = [], page = {} } = form?.details ?? {};
  const { header = {} as FormPageFieldHeader, submission = {} as FormsPageSubmissionConfig, branding = {} } = page ?? {};
  const fields = insertFieldsState( rawFields, store )
  const formData = insertRecordFormData( formId, response.record, store, true, true )
  console.log("Success Page", formId, store.formPage.data, fields, header, submission, branding, page, form, formData, response.record)
  const title = () => submission?.title?.content ? renderTemplate( submission?.title?.content, formData, {render_as: submission.title?.render_as || 'markdown', ...submission}).value : <></>
    const body = () => response.error ? <><h2>An Error occurred: {response.msg}.</h2> <p>Please try again or contact the Form Admin.</p></> : renderTemplate( submission?.content?.content, formData, {render_as: submission.content?.render_as || 'markdown', ...submission}).value
  const footer = () => {
      const btnStyle = {marginRight: '0.5rem', marginBottom: '0.5rem', }

      return <div className={'flex flex-wrap md:flex-nowrap'} style={{width: '100%'}}>
          {!submission.next?.hidden && submission.next?.url && <Button style={{...btnStyle, ...(submission.next?.style || {})}}
             icon={toIcon(submission.next?.icon || 'external-link')} className={`flex ${submission.next?.class || 'p-button-success p-button-outline p-button-raised'}`}
             label={renderTemplate( submission.next?.content || 'View Record', formData, {render_as: 'plain'}).output}
             onClick={openUrl(renderTemplate( submission.next.url, formData, {render_as: 'plain'}).output, submission.next_location,true )}/>}
          {!isEditMode && !submission.create_new?.hidden && <Button style={{...btnStyle, ...(submission.create_new?.style || {})}}
          icon={toIcon(submission.create_new?.icon || 'undo')} className={`flex ${submission.create_new?.class || 'p-button-outline p-button-raised'}`}
          label={renderTemplate( submission.create_new?.content || 'Submit New Entry', formData, {render_as: 'plain'}).output}
          onClick={openUrl( response.href, submission.create_new_location || 'self', true)}/>}
          {!submission.refresh_edit?.hidden && <Button style={{...btnStyle, ...(submission.refresh_edit?.style || {})}}
            icon={toIcon(submission.refresh_edit?.icon || 'refresh')} className={`flex ${submission.refresh_edit?.class || 'p-button-success p-button-outline p-button-raised'}`}
            label={renderTemplate( submission.refresh_edit?.content || 'Refresh & Edit', formData, {render_as: 'plain'}).output}
            onClick={openUrl( toEditUrl(response.href, response.record?.tableRecordId), '', true)}/>}
      </div>
  }
  if(mode === 'dev' && formId && _isBlank(response)){
    return (<ProgressBar mode="indeterminate" />)
  }
  return _isBlank(response) ? (
          <div className={cls.wrapper}>
              Form Submission Page No Longer Active
              <div className={cls.btnWrapper}>
                  <Button onClick={openUrl(window.location.href.replace('/success','/form'), 'self', true)}>Submit new entry</Button>
              </div>
          </div>

      ) :
      (
    <div className={cls.wrapper}>
        {toBool(submission.header, false) &&  <FormHeader header={header} />}
        {submission?.card ? <Card header={title()} footer={footer()}>
                {body()}
        </Card> : <>
            {body()}
            {footer()}
        </>}
        <Branding details={{...branding, position: 'bottom'}}  location={'submit'} />
    </div>
  );
};

export default Submitted;
